import { useWebsite } from 'hooks/website/useWebsite';

import s from './ClassicPreviewImage.module.css';

export const ClassicPreviewImage = () => {
  const {
    home: {
      hero: { image: heroImageSrc },
    },
  } = useWebsite();

  return (
    <div
      role="img"
      title="Classic Image Preview"
      className={s.image}
      style={{
        backgroundImage: `url(${heroImageSrc})`,
      }}
    />
  );
};
